<template>
  <form @submit.prevent="checkVer">
      <vue-recaptcha @verify="markVer"
        ref="recaptcha"
        sitekey="6LdkjoEUAAAAADvPFMADQVBgowQ6CK_HAYGkSltv">
      </vue-recaptcha>
      <div class="v-text-field__details">
        <div class="v-messages theme--light error--text">
          <div class="v-messages__wrapper">
            <div class="v-messages__message text-xs-left red--text">{{ tickMsg }}</div>
          </div>
        </div>
      </div>
  </form>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha'
export default {
  name: 'Captcha',
  props: ['verified', 'rules', 'status'],
  components: { VueRecaptcha },
  data: () => ({
    tickMsg: ''
  }),
  methods: {
    markVer (response) {
      this.$emit('verify', true)
    },
    checkVer () {
      if (!this.verified) {
        this.tickMsg = this.rules
      }
    }
  },
  computed: {
    appMode () {
      return process.env.VUE_APP_MODE
    }
  },
  watch: {
    status (val) {
      if (!val) this.checkVer()
      else this.tickMsg = ''
    },
    verified (val) {
      if (!val) {
        this.$refs.recaptcha.reset()
      }
    }
  }
}
</script>
